import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import {
    Container, Box, Paper, Typography, TextField, Button,
    Alert, CircularProgress
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import { changePassword, signout, isAuthenticated } from "../auth";
import { updateUser } from "./apiUser";

class ForceChangePassword extends Component {
    constructor() {
        super();
        this.state = {
            currentPassword: "",
            newPassword: "",
            confirmPassword: "",
            error: "",
            loading: false,
            redirectToHome: false,
            redirectToSignin: false
        };
    }

    handleChange = name => event => {
        this.setState({ error: "", [name]: event.target.value });
    };

    handleSubmit = e => {
        e.preventDefault();
        const { currentPassword, newPassword, confirmPassword } = this.state;

        if (!currentPassword || !newPassword || !confirmPassword) {
            return this.setState({ error: "All fields are required" });
        }
        if (newPassword.length < 12) {
            return this.setState({ error: "New password must be at least 12 characters" });
        }
        if (!/[a-z]/.test(newPassword)) {
            return this.setState({ error: "New password must contain a lowercase letter" });
        }
        if (!/[A-Z]/.test(newPassword)) {
            return this.setState({ error: "New password must contain an uppercase letter" });
        }
        if (!/\d/.test(newPassword)) {
            return this.setState({ error: "New password must contain a number" });
        }
        if (!/[!@#$%^&*(),.?":{}|<>]/.test(newPassword)) {
            return this.setState({ error: "New password must contain a special character" });
        }
        if (newPassword !== confirmPassword) {
            return this.setState({ error: "New passwords do not match" });
        }
        if (currentPassword === newPassword) {
            return this.setState({ error: "New password must be different from current password" });
        }

        this.setState({ loading: true });

        changePassword({ currentPassword, newPassword }).then(data => {
            if (data.error) {
                this.setState({ error: data.error, loading: false });
            } else {
                updateUser({ mustChangePassword: false }, () => {
                    this.setState({ redirectToHome: true });
                });
            }
        }).catch(() => {
            this.setState({ error: "Server error. Please try again.", loading: false });
        });
    };

    handleSignout = () => {
        signout(() => {
            this.setState({ redirectToSignin: true });
        });
    };

    render() {
        if (this.state.redirectToHome) return <Redirect to="/usershome" />;
        if (this.state.redirectToSignin) return <Redirect to="/signin" />;
        if (!isAuthenticated()) return <Redirect to="/signin" />;

        return (
            <Container maxWidth="sm" sx={{ mt: 5, mb: 5 }}>
                <Paper elevation={3} sx={{ p: 4 }}>
                    <Box sx={{ textAlign: 'center', mb: 3 }}>
                        <LockIcon sx={{ fontSize: 48, color: '#003E7E', mb: 1 }} />
                        <Typography variant="h4" component="h2" gutterBottom>
                            Change Your Password
                        </Typography>
                        <Typography variant="body1" color="text.secondary">
                            For security reasons, you must change your password before continuing.
                        </Typography>
                    </Box>

                    {this.state.error && (
                        <Alert severity="error" sx={{ mb: 3 }}>
                            {this.state.error}
                        </Alert>
                    )}

                    {this.state.loading ? (
                        <Box sx={{ display: 'flex', justifyContent: 'center', py: 5 }}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        <Box component="form" onSubmit={this.handleSubmit}>
                            <TextField
                                fullWidth
                                label="Current Password"
                                type="password"
                                value={this.state.currentPassword}
                                onChange={this.handleChange("currentPassword")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                            <TextField
                                fullWidth
                                label="New Password"
                                type="password"
                                value={this.state.newPassword}
                                onChange={this.handleChange("newPassword")}
                                margin="normal"
                                variant="outlined"
                                required
                                helperText="At least 12 characters with uppercase, lowercase, number, and special character"
                            />
                            <TextField
                                fullWidth
                                label="Confirm New Password"
                                type="password"
                                value={this.state.confirmPassword}
                                onChange={this.handleChange("confirmPassword")}
                                margin="normal"
                                variant="outlined"
                                required
                            />
                            <Button
                                fullWidth
                                type="submit"
                                variant="contained"
                                color="primary"
                                size="large"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                Change Password
                            </Button>
                            <Box sx={{ textAlign: 'center' }}>
                                <Button color="secondary" onClick={this.handleSignout}>
                                    Sign Out Instead
                                </Button>
                            </Box>
                        </Box>
                    )}
                </Paper>
            </Container>
        );
    }
}

export default ForceChangePassword;
